// frontend/src/layout/Layout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

function Layout() {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-6 lg:p-10">
        <Header />
        <div className="mt-8">
          <Outlet /> {/* This is where our page components will be rendered */}
        </div>
      </main>
    </div>
  );
}

export default Layout;
